import { type CSSProperties, type FC } from 'react'

import { getScheduleStaffInitials } from 'features/Home/Book/Booking/Schedule/PatientSchedule/ScheduleCalendar/scheduleInstance'

import styles from './ehrAppointmentV2.module.scss'

export const PROVIDER_TEXT = {
  label: 'Appointment with',
  primary: 'Primary',
  makePrimary: 'Make primary',
  addProvider: 'Add provider',
  menuTitle: 'Select one or more',
  menuTitleOne: 'Select one',
  done: 'Done',
  addMore: 'Add more providers to make it a joint appointment (one visit, several providers).',
  jointEdit:
    'Changes here update the whole visit: every provider’s copy in OpenEMR is added, removed or updated.',
  required: 'Pick at least one provider.',
} as const

export type PersonOption = { id: number; name: string; role: string; color: string }

// Initials and color as the doctor rail shows them.
export const Avatar: FC<{ person: PersonOption }> = ({ person }) => (
  <span
    className={styles.providerAvatar}
    style={{ '--staff-color': person.color } as CSSProperties}
    aria-hidden>
    {getScheduleStaffInitials(person.name)}
  </span>
)
